export function calculateLocation(location) {
    const expressions = [
        /at (.+)/m, // In-Person at UCL
        /in (.+)/m, // In-Person in California
        /\(.+\)/m, // In-Person (UCL & Other Locations)
    ];

    for (let i = 0; i < expressions.length; i++) {
        let expression = expressions[i];
        let match = location.match(expression);

        if (match && match[0]) {
            return {
                location: location.replace(match[0], '').trim(),
                actual_location: match[0].replace('(', '').replace(')', ''),
            }
        }
    }

    return {
        location,
        actual_location: null,
    };
}
